"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function round(num, precision) {
    if (precision === void 0) { precision = 0; }
    var pow = Math.pow(10, (precision >= 0 ? precision : 0));
    return Math.round(num * pow) / pow;
}
exports.round = round;
function commatize(num, options) {
    if (options === void 0) { options = {}; }
    var _a = options.division, division = _a === void 0 ? 3 : _a, _b = options.separator, separator = _b === void 0 ? ',' : _b;
    return ("" + num).replace(/\b(\d+)((\.\d+)*)\b/g, function (raw, integer, decimal) { return (integer.charAt(0) > 0 && !(decimal || '.').lastIndexOf('.')
        ? integer.replace(new RegExp("(\\d)(?=(\\d{" + division + "})+$)", 'g'), "$1" + separator)
        : integer) + decimal; });
}
exports.commatize = commatize;
